export default __webpack_public_path__ + "static/media/WorkArtParticleBack.5349ad08.jpg";